import type { FunctionComponent } from 'react'

export const OverviewIllustration: FunctionComponent<{
	children?: never
}> = () => (
	<svg width="82" height="90" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="64.488" height="90" rx="4" fill="#fff" />
		<rect
			x="8.339"
			y="12.656"
			width="23.627"
			height="4.219"
			rx="2.109"
			fill="#E7E8EE"
		/>
		<rect
			x="8.339"
			y="21.094"
			width="27.797"
			height="4.219"
			rx="2.109"
			fill="#E7E8EE"
		/>
		<rect
			x="8.339"
			y="29.531"
			width="19.458"
			height="4.219"
			rx="2.109"
			fill="#E7E8EE"
		/>
		<rect
			x="50.034"
			y="12.656"
			width="8.339"
			height="4.219"
			rx="2.109"
			fill="#E7E8EE"
		/>
		<rect
			x="50.034"
			y="21.094"
			width="8.339"
			height="4.219"
			rx="2.109"
			fill="#E7E8EE"
		/>
		<rect
			x="50.034"
			y="29.531"
			width="8.339"
			height="4.219"
			rx="2.109"
			fill="#E7E8EE"
		/>
		<rect
			x="8.339"
			y="37.969"
			width="23.627"
			height="4.219"
			rx="2.109"
			fill="#E7E8EE"
		/>
		<rect
			x="8.339"
			y="46.406"
			width="27.797"
			height="4.219"
			rx="2.109"
			fill="#E7E8EE"
		/>
		<rect
			x="8.339"
			y="54.844"
			width="19.458"
			height="4.219"
			rx="2.109"
			fill="#E7E8EE"
		/>
		<rect
			x="50.034"
			y="37.969"
			width="8.339"
			height="4.219"
			rx="2.109"
			fill="#E7E8EE"
		/>
		<rect
			x="50.034"
			y="46.406"
			width="8.339"
			height="4.219"
			rx="2.109"
			fill="#E7E8EE"
		/>
		<rect
			x="50.034"
			y="54.844"
			width="8.339"
			height="4.219"
			rx="2.109"
			fill="#E7E8EE"
		/>
		<rect
			x="8.339"
			y="63.281"
			width="23.627"
			height="4.219"
			rx="2.109"
			fill="#E7E8EE"
		/>
		<rect
			x="8.339"
			y="80.156"
			width="19.458"
			height="4.219"
			rx="2.109"
			fill="#67CB99"
		/>
		<rect
			x="50.034"
			y="63.281"
			width="8.339"
			height="4.219"
			rx="2.109"
			fill="#E7E8EE"
		/>
		<rect
			x="50.034"
			y="80.156"
			width="8.339"
			height="4.219"
			rx="2.109"
			fill="#67CB99"
		/>
		<rect
			x="49.394"
			y="44.344"
			width="31.856"
			height="32.25"
			rx="15.928"
			fill="#565CD4"
		/>
		<rect
			x="49.394"
			y="44.344"
			width="31.856"
			height="32.25"
			rx="15.928"
			stroke="#fff"
			strokeWidth="1.5"
		/>
		<mask
			id="a"
			style={{ maskType: 'alpha' }}
			maskUnits="userSpaceOnUse"
			x="52"
			y="47"
			width="26"
			height="27"
		>
			<path fill="#D9D9D9" d="M52.644 47.594H78v25.75H52.644z" />
		</mask>
		<g mask="url(#a)">
			<path
				d="M67.435 57.251c-.3 0-.55-.102-.753-.308a1.046 1.046 0 0 1-.304-.765c0-.304.101-.558.304-.764.202-.206.453-.309.753-.309h7.395c.3 0 .55.103.753.309.202.206.304.46.304.764s-.102.56-.304.765a1.014 1.014 0 0 1-.753.308h-7.395Zm0 8.584c-.3 0-.55-.103-.753-.309a1.047 1.047 0 0 1-.304-.764c0-.304.101-.56.304-.765.202-.205.453-.308.753-.308h7.395a1.046 1.046 0 0 1 1.056 1.073c0 .304-.1.558-.303.764a1.014 1.014 0 0 1-.753.309h-7.395Zm-9.667-7.189-2.272-2.307a1.026 1.026 0 0 1-.29-.75c0-.305.096-.555.29-.752a.994.994 0 0 1 .74-.295c.3 0 .546.099.74.295l1.505 1.53 3.75-3.81a.96.96 0 0 1 .74-.308c.282.009.528.12.74.335.193.215.29.465.29.751s-.097.537-.29.751l-4.464 4.56a1.006 1.006 0 0 1-.74.322c-.282 0-.528-.107-.74-.322Zm0 8.583-2.272-2.306a1.026 1.026 0 0 1-.29-.751c0-.304.096-.555.29-.751a.994.994 0 0 1 .74-.295c.3 0 .546.098.74.295l1.505 1.529 3.75-3.81a.96.96 0 0 1 .74-.308c.282.01.528.12.74.335.193.215.29.465.29.752 0 .286-.097.536-.29.75l-4.464 4.56a1.006 1.006 0 0 1-.74.322c-.282 0-.528-.107-.74-.322Z"
				fill="#fff"
			/>
		</g>
	</svg>
)
